"use client"

import { useTranslations } from "next-intl"
import { Button, TbPrinter } from "@forestsync/ui"

// The registry's certificate is the page itself, printed (the browser's "Save as PDF"); anything
// not part of the certificate carries print:hidden. Shared by the transaction certificate and the
// per-item record page.
export function PrintCertificateButton() {
  const t = useTranslations("certificate")
  return (
    <div className="print:hidden mt-6 flex justify-end">
      <Button leftSection={<TbPrinter size={18} />} onClick={() => window.print()} variant="filled">
        {t("downloadCertificate")}
      </Button>
    </div>
  )
}
